import { render, staticRenderFns } from "./PersonBanner.vue?vue&type=template&id=3bf9551e&scoped=true"
import script from "./PersonBanner.vue?vue&type=script&lang=js"
export * from "./PersonBanner.vue?vue&type=script&lang=js"
import style0 from "./PersonBanner.vue?vue&type=style&index=0&id=3bf9551e&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf9551e",
  null
  
)

export default component.exports